"use client";

import React from "react";
import { ImageBox } from "./image-box";

interface ImageBoxGridProps {
  features: {
    heading: string;
    description: string;
    image: any;
    href: string | null;
  }[];
}

export const ImageBoxGrid = ({ features }: ImageBoxGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {features.map((feature, index) => (
        <ImageBox key={feature.heading} feature={feature} index={index} />
      ))}
    </div>
  );
};
